import Vue from "vue"
import loading from "../../components/DokLoading"
import App from "./App.vue"
import "./index.scss"

Vue.config.productionTip = false
window.showLoading = loading.open // 显示 Loading 提示框
window.hideLoading = loading.close // 隐藏 Loading 提示框
new Vue({
  render: (h) => h(App)
}).$mount("#app")
